export default ['$rootScope', '$scope', 'LandCategoryService', 'MunicipalityService', 'OperatorService',
    function ($rootScope, $scope, LandCategoryService, MunicipalityService, OperatorService) {

        $rootScope.title = "Земельные участки";

        $scope.update = update;
        $scope.isBetween = OperatorService.isBetween;
        $scope.getOperatorDisplayName = OperatorService.getDisplayName;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.filter = getDefault();
            $scope.filters = [];
            $scope.def = {};

            OperatorService.api.default(null, (data) => {
                $scope.defaultOperator = data._embedded;
                $scope.filter = getDefault();
            });
        }

        function getDefault() {
            return {
                operatorArea: $scope.defaultOperator,
                municipality: null,
                category: null
            };
        }

        function update() {
            $scope.filters = [];
            if ($scope.filter.municipality != null)
                $scope.filters.push("'municipality.id' EQ '" + $scope.filter.municipality + "'");

            if ($scope.filter.category != null) {
                $scope.filters.push("'category.id' EQ '" + $scope.filter.category + "'");
            }

            if ($scope.filter.area1 != null)
                if ($scope.isBetween($scope.filter.operatorArea)) {
                    $scope.filters.push("'area' GE '" + $scope.filter.area1 + "'");
                    if ($scope.filter.area2 != null)
                        $scope.filters.push("'area' LE '" + $scope.filter.area2 + "'");
                } else
                    $scope.filters.push("'area' " + $scope.filter.operatorArea + " '" + $scope.filter.area1 + "'");
        }

        // endregion

        // region watchers

        $scope.$watch("filter.municipality", () => {
            $scope.def.municipality = null;
            if ($scope.filter.municipality != null && Array.isArray($scope.municipalities))
                $scope.def.municipality = $scope.municipalities.find(o => o.id == $scope.filter.municipality);
        });

        $scope.$watch("$scope.filter.category", () => {
            $scope.def.category = null;
            if ($scope.filter.category != null && Array.isArray($scope.categories))
                $scope.def.category = $scope.categories.find(o => o.id == $scope.filter.category);
        });

        $scope.$watch("$scope.filter.operatorArea", () => {
            $scope.def.area = null;
            if ($scope.filter.area1 != null && $scope.filter.operatorArea == "EQ")
                $scope.def.area = $scope.filter.area1;
        });

        $scope.$watch("$scope.filter.area1", () => {
            $scope.def.area = null;
            if ($scope.filter.area1 != null && $scope.filter.operatorArea == "EQ")
                $scope.def.area = $scope.filter.area1;
        });

        // endregion

    }];